<div style="width: 100%;">
    <mat-card>
        <div class="divtitle">
            <span class="flex-container" style="padding: 8px;">
                <div class="label">{{'scanner.label' | transloco}}</div>
            </span>
        </div>

        <mat-card class="box">
            <label class="infoLabel">{{ 'scanner.text' | transloco }}</label>
            <div class="dnd">

                <div class="deviceSelector" *ngIf="isActive">
                    <mat-form-field>
                        <mat-label>{{ 'scanner.selectCamera' | transloco }}</mat-label>
                        <mat-select mat-select #select1 (selectionChange)="action.playDevice(select1.value)" class="form-select form-select-md">
                            <mat-option [value]="null" selected>{{ 'scanner.select' | transloco }}</mat-option>
                            <mat-option *ngFor="let c of action.devices.value; let i = index" [value]="c.deviceId"
                                [selected]="i == action.deviceIndexActive">{{c.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div style="background-color: #262626; width: 400px; height: 400px;">
                    <ngx-scanner-qrcode class="scanner" [isBeep]=true [stopAfterScan]=true #action="scanner" [config]="config"
                        (event)="onEvent($event, action)"></ngx-scanner-qrcode>
                </div>
            </div>
        </mat-card>
    </mat-card>
</div>